import {ClientConnectAutoRemove, ClientConnectMessageName} from 'enums';
import {TRANSLATION_KEYS} from 'locale';
import {sessionUtils} from 'utils/session';

const AUTO_REMOVE_T_KEYS = TRANSLATION_KEYS.USER.ACCOUNT.CLIENTS_CONNECTIONS.AUTO_REMOVE_OPTIONS;

// TODO: remove after removing client connect contacts
export const ClientConnectFieldPath = {
    ...(sessionUtils.getUserInfoFieldsPath({pathPrefix: 'userInfo'})),
    AGENT_EMAIL: 'agent.email',
    ASSIGNMENT_INFO: 'assignmentInfo',
    GROUP: 'assignmentInfo.groupId',
    SUBGROUP: 'assignmentInfo.subgroupId',
    COMMENTS: 'comments',
    PHONE: 'contacts.phone',
    EMAIL: 'contacts.email',
    AUTO_REMOVE: 'autoRemove'
};

export const CLIENT_CONNECT_AUTO_REMOVE_TRANSLATE = {
    [ClientConnectAutoRemove.Never]: AUTO_REMOVE_T_KEYS.NEVER,
    [ClientConnectAutoRemove.AfterFirstAnsweredSession]: AUTO_REMOVE_T_KEYS.AFTER_FIRST_ANSWERED_SESSION,
    [ClientConnectAutoRemove.AfterFirstSuccessfulSession]: AUTO_REMOVE_T_KEYS.AFTER_FIRST_SUCCESSFUL_SESSION
};

export const SMS_MAX_LENGTH = 320;

export const WITH_LOGO_MESSAGES = [
    ClientConnectMessageName.ClientAppConfigIos,
    ClientConnectMessageName.ClientAppConfigAndroid
];
